import { cn } from '../../utils/cn';

const STATUS_BG = {
  ok: 'bg-emerald-500',
  exceeded: 'bg-red-600',
  no_budget: 'bg-stone-300 dark:bg-stone-600',
  allocated: 'bg-sage-600',
};

const STATUS_TRACK = {
  ok: 'bg-emerald-100',
  exceeded: 'bg-red-100',
  no_budget: 'bg-muted',
  allocated: 'bg-sage-100',
};

function clampPct(value) {
  if (value === null || value === undefined) return 0;
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return Math.max(0, Math.min(100, num));
}

export function CategoryBudgetProgressBar({
  status = 'ok',
  percentage = 0,
  className,
  ariaLabel,
}) {
  const width = clampPct(percentage);
  return (
    <div
      role="progressbar"
      aria-valuenow={width}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
      className={cn('h-2 w-full overflow-hidden rounded-full', STATUS_TRACK[status] || STATUS_TRACK.no_budget, className)}
    >
      <div
        className={cn('h-full rounded-full transition-all', STATUS_BG[status] || STATUS_BG.no_budget)}
        style={{ width: `${width}%` }}
      />
    </div>
  );
}
